var LOCATIONS = [
  {label: 'Any Campus', value: null},
  {label: 'Warrnambool', value: 'Warrnambool'},
  {label: 'Sherwood Park', value: 'Sherwood Park'},
  {label: 'Hamilton', value: 'Hamilton'},
  {label: 'Portland', value: 'Portland'},
  {label: 'Colac', value: 'Colac'},
  { label: 'Stawell', value: 'Stawell' },
  { label: 'Glenormiston', value: 'Glenormiston' },
  { label: 'South Australia', value: 'South Australia' },
  {label: 'Workplace Training', value: 'Workplace Training'}
];

var STUDY_MODES = [
  {label: 'Any mode', value: null},
  {label: 'Full-time', value: 'Full-time'},
  {label: 'Part-time', value: 'Part-time'},
  {label: 'Apprenticeship', value: 'Apprenticeship'},
  {label: 'Traineeship', value: 'Traineeship'},
  {label: 'Short Course', value: 'Short Course'}
];

var STUDY_AREAS = [
  {label: 'All Study Areas', value: null},
  {label: 'Agriculture & Horticulture', value: 'Agriculture & Horticulture'},
  {label: 'Arts', value: 'Arts'},
  {label: 'Building & Construction', value: 'Building & Construction'},
  {label: 'Business', value: 'Business'},
  {label: 'Civil Construction', value: 'Civil Construction'},
  {label: 'Electrical', value: 'Electrical'},
  {label: 'Engineering', value: 'Engineering'},
  {label: 'Food & Hospitality', value: 'Food & Hospitality'},
  {label: 'Hair, Beauty & Wellness', value: 'Hair, Beauty & Wellness'},
  {label: 'Health & Community Services', value: 'Health & Community Services'},
  {label: 'High Risk Work Licences', value: 'High Risk Work Licences'},
  {label: 'Motorcycle Licences', value: 'Motorcycle Licences'},
  {label: 'OHS', value: 'OHS'}
];
